/* Offer selection UI; real gift cart lines are synchronized by mfvg-cart-sync.js. */
(() => {
  'use strict';
  if (customElements.get('mfvg-cart-progress')) return;
  function updateFlexibleQuantity(input) {
    const card = input.closest('[data-mfvg-flex]');
    if (!card) return;
    const quantity = Math.max(3, Math.min(99, Math.floor(Number(input.value) || 3)));
    input.value = String(quantity);
    card.dataset.quantity = String(quantity);
    const radio = card.querySelector('input[type="radio"]');
    radio.checked = true;
    radio.value = String(quantity);
    const holder = card.querySelector('.mfvg-variants');
    if (holder) {
      const rows = [...holder.querySelectorAll('.mfvg-copy-row')];
      const template = rows[0];
      if (template) {
        rows.slice(quantity).forEach(row => row.remove());
        const variant = input.closest('product-info')?.querySelector('product-form input[name="id"]')?.value;
        for (let number = rows.length; number < quantity; number++) {
          const copy = template.cloneNode(true);
          const select = copy.querySelector('[data-offer-variant]');
          if (variant && [...select.options].some(option => option.value === variant)) select.value = variant;
          delete select.dataset.edited;
          holder.append(copy);
        }
        holder.querySelectorAll('.mfvg-copy-row').forEach((row, index) => {
          row.querySelector('label > span').textContent = `#${index + 1}`;
          row.querySelector('[data-offer-variant]').setAttribute('aria-label', (holder.dataset.copyLabel || '#__number__').replace('__number__', String(index + 1)));
        });
      }
    }
    card.querySelector('[data-mfvg-step="-1"]').disabled = quantity <= 3;
    card.querySelector('[data-mfvg-step="1"]').disabled = quantity >= 99;
  }
  // Capture before the existing product controller calculates the price and selected variants.
  document.addEventListener('change', event => {
    if (event.target.matches('[data-mfvg-quantity]')) updateFlexibleQuantity(event.target);
  }, true);
  document.addEventListener('input', event => {
    const input = event.target;
    if (!input.matches('[data-mfvg-quantity]')) return;
    const quantity = Number(input.value);
    // Leave intermediate digits alone (for example the 1 while typing 10).
    if (input.value !== '' && Number.isInteger(quantity) && quantity >= 3 && quantity <= 99) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-mfvg-step]');
    if (!button || button.disabled) return;
    const input = button.closest('[data-mfvg-flex]').querySelector('[data-mfvg-quantity]');
    input.value = String((Number(input.value) || 3) + Number(button.dataset.mfvgStep));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);
  document.addEventListener('click', event => {
    const swatch = event.target.closest('[data-mfvg-variant]');
    if (swatch) {
      const row = swatch.closest('.mfvg-copy-row');
      const select = row?.querySelector('[data-offer-variant]');
      if (select) { select.value = swatch.dataset.mfvgVariant; select.dispatchEvent(new Event('change', { bubbles: true })); }
      row?.querySelectorAll('[data-mfvg-variant]').forEach(button => {
        const active = button === swatch;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      return;
    }
    const card = event.target.closest('.mfvg-offer');
    if (!card || event.target.closest('select,option,input,label,button,a')) return;
    const radio = card.querySelector('input[type="radio"]');
    if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
  });
  document.addEventListener('change', event => {
    if (!event.target.closest('product-info')) return;
    document.querySelectorAll('.mfvg-copy-row').forEach(row => {
      const value = row.querySelector('[data-offer-variant]')?.value;
      row.querySelectorAll('[data-mfvg-variant]').forEach(button => {
        const active = value === button.dataset.mfvgVariant;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    });
  });
  class GiftProgress extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-mfvg-increase]');
        if (!button || button.disabled) return;
        const host = this.closest('cart-drawer-items,cart-items');
        const input = [...(host?.querySelectorAll('input[name="updates[]"]') || [])]
          .find(input => input.dataset.quantityLineKey === button.dataset.mfvgIncrease);
        const plus = input?.closest('quantity-input')?.querySelector('button[name="plus"]');
        if (!plus || plus.disabled || input.disabled) return;
        button.disabled = true;
        // Use the cart's own events, error handling, focus and section rendering.
        plus.click();
        setTimeout(() => { if (button.isConnected) button.disabled = false; }, 4000);
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('mfvg-cart-progress', GiftProgress);
})();
